$(() => {
    if (document.getElementById('freee-setting') != null) {
        $('.js-register-btn').on('click', function() {
            $('#freee_setting_register_form').submit();
        });

        $('.js-freee_setting_modal').click(function() {
            $('#freee-setting-modal').modal('show');
        });

        $('.js-freee-select').select2({
            width: '100%',
            placeholder: '選択してください',
            allowClear: true,
            language: 'ja',
            tags: true,
            dropdownParent: '#freee-setting-modal'
        });

        // PROBASE請求書品目　入力チェック
        let registered = $('.js-registered').text();
        $('input[name="invoice_content_item"]').on('focusout', function() {
            let invoice_content_item = $(this).val();
            let account_item = $('select[name="account_item"] option:selected').val();
            if (invoice_content_item != "" && registered.indexOf(invoice_content_item) >= 0) {
                $('.js-error').removeClass('d-none');
                $(this).addClass('is-invalid');
            } else {
                $('.js-error').addClass('d-none');
                $(this).removeClass('is-invalid');
            }
            checkDisabled(invoice_content_item, account_item);
        });

        // freee勘定科目 入力チェック
        $('select[name="account_item"]').on('change', function() {
            let account_item = $(this).val();
            let invoice_content_item = $('input[name="invoice_content_item"]').val();
            checkDisabled(invoice_content_item, account_item);
        });

        // 削除ボタン
        $('.js-remove').on('click', function() {
            $('input[name="id"]').val($(this).data('id'));
            $('#freee_remove_form').submit();
        });

        // 追加するボタンdisabledチェック
        function checkDisabled(invoice_content_item, account_item) {
            let registered = $('.js-registered').text();
            if (registered.indexOf(invoice_content_item) >= 0 || account_item == "") {
                $('.js-register-btn').prop('disabled', true);
            } else {
                $('.js-register-btn').prop('disabled', false);
            }
        }
    }
});
